import { useEffect } from 'react';
import site from '../data/site.json';

interface PageMeta {
  title: string;
  description: string;
  // Pfad der Seite, z. B. "/impressum" – daraus werden Canonical und og:url gebildet
  path: string;
  noindex?: boolean;
}

const upsertMeta = (attribute: 'name' | 'property', key: string, content: string) => {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

const upsertCanonical = (href: string) => {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

// Setzt Titel und Meta-Tags pro Route; scripts/prerender.js schreibt das Ergebnis ins statische HTML
export const usePageMeta = ({ title, description, path, noindex = false }: PageMeta) => {
  useEffect(() => {
    const url = `${site.url}${path}`;

    document.title = title;
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large');
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', url);
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertCanonical(url);
  }, [title, description, path, noindex]);
};
